import Correspondence from "../correspondence";
import {ICorrespondenceAuthor} from "~/interfaces/correspondenceInterfaces";

export default class Note extends Correspondence {
  form_submission_id: string;
  entry_id: string;
  detail_view_id: string;
  newNote: boolean;
  author: ICorrespondenceAuthor;
  html_text: string;
  mentions_dictionary: any;

  get isANote(): boolean {
    return true;
  }

  get needsTruncation(): boolean {
    return (this.text.length > 249)
  }

  get truncatedText(): string {
      return `${this.html_text.slice(0, 249)}...`
  }
}